<template>
  <div class="cat-Wrapper">
    <div class="cat-Wrapper_Content">
      <div class="cat-Header">
        <AppIcon
          :class="{
            'cat-Icon-has-items': hasItems
          }"
          :icon-name="icon"
          class="cat-Icon"
          height="32"
          width="32"
        />
        <div>
          <AppTitle
            v-if="$slots.title"
            :class="{ 'cat-Header_Title-has-items': hasItems }"
            :level="4"
            class="cat-Header_Title"
            disable-margin
          >
            <slot name="title" />
          </AppTitle>
          <AppTitle v-if="$slots.subtitle" :level="6" class="cat-Header_Subtitle" disable-margin>
            <slot name="subtitle" />
          </AppTitle>
        </div>
      </div>
      <div :class="{ 'cat-Content-empty': !hasItems }" class="cat-Content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import AppIcon from '@/components/ui/AppIcon/AppIcon'
import AppTitle from '@/components/ui/AppTitle/AppTitle'

defineOptions({
  name: 'CheckinsAutomationsTemplate'
})

defineProps({
  icon: {
    type: String,
    required: true
  },

  hasItems: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/app-table-helpers';

.cat-Wrapper {
  width: 100%;
  max-width: var(--ob-automations-page-width);
  padding: 0 $page-right-padding 0 $page-left-padding;
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;

  --cat-content-left-padding: 18px;
  --cat-content-right-padding: 18px;
}

.cat-Wrapper_Content {
  border-radius: $border-radius-md;
  border: 1px solid $grey-2-next;
  width: 100%;
}

.cat-Header {
  display: flex;
  height: 72px;
  padding: 18px 24px 18px 18px;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  border-bottom: 1px solid $grey-2-next;
}

.cat-Content {
  padding: 9px var(--cat-content-right-padding, 32px) 0 var(--cat-content-left-padding, 32px);
}

.cat-Content-empty {
  padding-bottom: 18px;
}

.cat-Header_Title {
  color: $dark-2;
  font-weight: fw('semi-bold');
  &-has-items {
    color: $primary-color-next;
  }
}

.cat-Header_Subtitle {
  color: $dark-3;

  --at-title-level-6-fs: 12px;
  --at-title-level-6-lh: 16px;
}

.cat-Icon {
  color: $dark-2;

  &-has-items {
    color: $primary-color-next;
  }
}
</style>
